export default __webpack_public_path__ + "static/media/884.95ebb833.png";